// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"a12e1f3f","845":"7241ac6c"}[chunkId] + ".chunk.js";
};